import cn from 'classnames';
import { Core, Drawer, Form, Layout } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useViewport } from '../../../../../../util/useViewport';
import { useCompanySetup } from '../../MasterDataProvider';
import DriverCommentInternalList from './DriverCommentInternalList';
import style from './style';

const { Button, Counter } = Core;
const { Column } = Layout;
const { useDrawerContext } = Drawer;

const Styled = styled(Column)`
  ${style}
`;

const DriverCommentInternal = () => {
  const {
    Components: { DriverCommentInternal: DriverCommentInternalField },
    values,
    setFieldValue,
  } = Form.useFormContext();
  const { openDrawer } = useDrawerContext();

  const dimensions = useViewport();
  const companySetup = useCompanySetup();

  const handleClick = React.useCallback(() => {
    openDrawer({
      titleStringId: 'commentList',
      component: <DriverCommentInternalList />,
      width: Math.min(500, dimensions?.width),
    });
  }, [dimensions?.width, openDrawer]);

  React.useEffect(() => {
    if (
      companySetup.data?.driverCommentMaxCharacters &&
      values?.comments?.driverInternal?.length > companySetup.data?.driverCommentMaxCharacters
    ) {
      setFieldValue('comments', {
        ...values?.comments,
        driverInternal: values?.comments?.driverInternal?.slice(0, companySetup.data?.driverCommentMaxCharacters),
      });
    }
  }, [
    companySetup.data?.driverCommentMaxCharacters,
    setFieldValue,
    values?.comments,
    values?.comments?.driverInternal,
  ]);

  if (!DriverCommentInternalField) {
    return null;
  }

  return (
    <Styled className={cn('driver-comment-internal')}>
      <div className="driver-comment-internal-section col">
        <DriverCommentInternalField
          rows={3}
          validationText={false}
          maxLength={companySetup.data?.driverCommentMaxCharacters}
        />
        <div className="comment-footer">
          <Button
            type="primary"
            onClick={handleClick}
            stringId="list"
            data-testid="list-driver-comment-internal-button"
            size="small"
          />
          <Counter
            maxLength={companySetup.data?.driverCommentMaxCharacters}
            text={values?.comments?.driverInternal}
            className="comment-counter"
            data-testid="driver-comment-internal-counter"
          />
        </div>
      </div>
    </Styled>
  );
};

export default DriverCommentInternal;
